import React, { Component } from "react";
import Layout from "./Layout";
import SEO from "./SEO";
import PostWrapper from "./ContentWrappers/PostWrapper";
import { HTMLContent } from "./Content";
import { Context } from "../state";

class LayoutPost extends Component {
  static contextType = Context;

  componentDidMount() {
    const [, dispatch] = this.context;
    dispatch({ type: "PAGE_TYPE", payload: "post" });
  }

  render() {
    const { markdownRemark: post } = this.props.data;
    const { frontmatter } = post;
    const image =
      frontmatter.featuredImage && frontmatter.featuredImage.childImageSharp
        ? frontmatter.featuredImage.childImageSharp.fluid.src
        : "";
    return (
      <Layout>
        <SEO
          title={frontmatter.title}
          description={frontmatter.description}
          article={true}
          image={image}
        />
        <PostWrapper
          content={post.htmlAst}
          contentComponent={HTMLContent}
          frontmatter={frontmatter}
        />
      </Layout>
    );
  }
}

export default LayoutPost;
